import locationApi from '../services/locationApi'

// Un trou de données détecté (voir location-service, package trou).
export interface Trou {
  id: string
  type: string
  celluleI?: number
  celluleJ?: number
  centreLat?: number
  centreLng?: number
  zoneLabel?: string
  categoryMain?: string
  categorySub?: string
  attribut?: string
  volume: number
  scorePriorite: number
  confiance: number
  ancienneteJours?: number
  coutEstimeTips?: number
  coutEstimeFcfa?: number
  source?: string
  details?: Record<string, any>
}

export interface Synthese {
  lotId: string
  genereLe: string
  totalNonSupprime: number
  parSourceStatut: Record<string, number>
  sansCategoryMain: number
  sansPhoto: number
  osmNonConfirmes: number
  nbTrousParType: Record<string, number>
  volumeEstimeSousDensite: number
  nbMaillesPeuplees: number
  sourcesReference?: Record<string, any>
}

export interface PageTrous {
  contenu: Trou[]
  page: number
  taille: number
  total: number
}

export interface FiltreTrous {
  type?: string
  categorie?: string
  source?: string
  scoreMin?: number
  latMin?: number
  latMax?: number
  lngMin?: number
  lngMax?: number
  page?: number
  taille?: number
}

export async function getTrous(params: FiltreTrous): Promise<PageTrous> {
  const res = await locationApi.get('/trou', { params })
  return res.data
}

export async function getSynthese(): Promise<Synthese | null> {
  const res = await locationApi.get('/trou/synthese')
  return res.data
}

export async function getSyntheseZone(params: {
  latMin: number; latMax: number; lngMin: number; lngMax: number
}): Promise<any> {
  const res = await locationApi.get('/trou/synthese/zone', { params })
  return res.data
}

export async function lancerDetection(): Promise<Synthese> {
  const res = await locationApi.post('/trou/detecter', {})
  return res.data
}

export async function genererQuete(id: string): Promise<any> {
  const res = await locationApi.post(`/trou/${id}/quete`, {})
  return res.data
}

export async function getMesure(): Promise<any> {
  const res = await locationApi.get('/trou/mesure')
  return res.data
}

export interface SourceAttribution { nom: string; version: string; licence: string; disponible: boolean }
export interface IndicateurSante {
  nbStructuresHdx: number
  populationDakar: number
  nbLocalites: number
  santePour10000: number | null
  sources: SourceAttribution[]
}

export async function getIndicateurSante(): Promise<IndicateurSante> {
  const res = await locationApi.get('/trou/indicateur-sante')
  return res.data
}

// Libellés lisibles des types de trous.
export const LIBELLE_TYPE: Record<string, string> = {
  ATTRIBUT_MANQUANT: 'Attribut manquant',
  NON_VERIFIE: 'Non vérifié (référentiel)',
  PERIME: 'Périmé',
  SOUS_DENSITE: 'Sous-densité',
  SOURCE_REFERENCE: 'Source de référence',
  CLASSIFICATION_INCORRECTE: 'Classement incorrect',
}

// Couleur d'un score de priorité 0-100, couleurs de la charte lisibles en
// texte (le score s'affiche aussi en chiffre) : critique orange, forte ocre,
// moyenne bleu, faible et minime gris (texte secondaire).
export function couleurScore(score: number): string {
  if (score >= 75) return '#A23A0D'
  if (score >= 55) return '#7C5600'
  if (score >= 35) return '#1D5FA4'
  return '#57534A'
}
